/** 상·하 표 분할 비율(%) — GR09 입고조회 2.0 과 같은 값. */
export const SPLIT_TOP_PERCENT = 45
export const MAX_SEARCH_DAYS = 31
export const DETAIL_DEFAULT_PAGE_SIZE = 1000
export const DETAIL_MID_PAGE_SIZE = 5000
export const DETAIL_MAX_PAGE_SIZE = 10000
export const DATE_PARAM_FORMAT = 'YYYYMMDD'
